export const pcRoutes = [
  {
    path: "/",
    name: "BasicLayout",
    meta: { title: "" },
    redirect: "/home",
    component: () =>
      import(
        /* webpackChunkName: "basiclayout" */ "../views/PC/Layout/BasicLayout.vue"
      ),
    children: [
      {
        path: "step1",
        name: "Step1",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "step1" */ "../views/PC/Step1.vue"),
      },
      {
        path: "step2",
        name: "Step2",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "step2" */ "../views/PC/Step2.vue"),
      },
      {
        path: "course",
        name: "Course",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "course" */ "../views/PC/Course.vue"),
      },
      {
        path: "series",
        name: "SeriesCourse",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "seriescourse" */ "../views/PC/SeriesCourse.vue"
          ),
      },
      {
        path: "allcourse",
        name: "AllCourse",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "allcourse" */ "../views/PC/AllCourse.vue"
          ),
      },
      {
        path: "publiccourse",
        name: "PublicCourse",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "PCPublicCourse" */ "../views/PC/PublicCourse.vue"
          ),
      },
      {
        path: "home",
        name: "Home",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/PC/Home.vue"),
      },
      {
        path: "allcourse2",
        name: "AllCourse2",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "allcourse2" */ "../views/PC/AllCourse2.vue"
          ),
      },
      {
        path: "education",
        name: "Education",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "education" */ "../views/PC/Education.vue"
          ),
      },
    ],
  },
  {
    path: "/goodinfo",
    name: "GoodInfo",
    meta: { title: "" },
    component: () =>
      import(/* webpackChunkName: "goodinfo" */ "../views/PC/GoodInfo.vue"),
  },
];

export const h5Routes = [
  {
    path: "/",
    meta: { title: "" },
    redirect: "/home",
    children: [
      {
        path: "step1",
        name: "Step1",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "H5Step1" */ "../views/H5/Step1.vue"),
      },
      {
        path: "step2",
        name: "Step2",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "H5Step2" */ "../views/H5/Step2.vue"),
      },
      {
        path: "home",
        name: "Home",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/H5/Home.vue"),
      },
      {
        path: "allcourse2",
        name: "AllCourse2",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "allcourse2" */ "../views/H5/AllCourse2.vue"
          ),
      },
      {
        path: "course",
        name: "Course",
        meta: { title: "" },
        component: () =>
          import(/* webpackChunkName: "H5Course" */ "../views/H5/Course.vue"),
      },
      {
        path: "series",
        name: "SeriesCourse",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "seriescourse" */ "../views/H5/SeriesCourse.vue"
          ),
      },
      {
        path: "allcourse",
        name: "AllCourse",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "H5allcourse" */ "../views/H5/AllCourse.vue"
          ),
      },
      {
        path: "publiccourse",
        name: "PublicCourse",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "H5PublicCourse" */ "../views/H5/PublicCourse.vue"
          ),
      },
      {
        path: "education",
        name: "Education",
        meta: { title: "" },
        component: () =>
          import(
            /* webpackChunkName: "H5Education" */ "../views/H5/Education.vue"
          ),
      },
    ],
  },
  {
    path: "/goodinfo",
    name: "GoodInfo",
    meta: { title: "" },
    component: () =>
      import(/* webpackChunkName: "H5Goodinfo" */ "../views/H5/GoodInfo.vue"),
  },
];
